export const SCHOOLS = [
  "Abendgymnasium mit Abendschule St. Georg",
  "Adolph-Diesterweg-Schule",
  "Albert-Schweitzer-Gymnasium",
  "Albert-Schweitzer-Schule",
  "Albrecht-Thaer-Gymnasium",
  "Alexander-von-Humboldt-Gymnasium",
  "Anton-Rée-Schule Allermöhe",
  "Aueschule Finkenwerder",
  "Bildungszentrum für Blinde und Sehbehinderte",
  "Campus HafenCity",
  "Campus Hebebrandstraße",
  "Campus Kieler Straße",
  "Campus Zweiter Bildungsweg",
  "Carl-Cohn-Schule",
  "Carl-Götze-Schule",
  "Carl-von-Ossietzky-Gymnasium",
  "Charlotte-Paulsen-Gymnasium",
  "Christianeum",
  "Clara-Grunwald-Schule",
  "Deutsch-Französisches Gymnasium",
  "Elbinselschule",
  "Elbkinder Grundschule",
  "Elbschule Bildungszentrum Hören und Kommunikation",
  "Elisabeth-Lange-Schule",
  "Emil Krause Schule",
  "Emilie-Wüstenfeld-Gymnasium",
  "Erich Kästner Schule",
  "Esther Bejarano Schule",
  "Fridtjof-Nansen-Schule",
  "Friedrich-Ebert-Gymnasium",
  "Fritz-Köhne-Schule",
  "Fritz-Schumacher-Schule",
  "Ganztagsgrundschule Am Johannisland",
  "Ganztagsgrundschule Sternschanze",
  "Ganztagsschule Fährstraße",
  "Ganztagsschule an der Elbe",
  "Gelehrtenschule des Johanneums",
  "Georg-Kerschensteiner-Grundschule",
  "Geschwister-Scholl-Stadtteilschule",
  "Goethe-Gymnasium",
  "Goethe-Schule-Harburg",
  "Goldbek-Schule",
  "Gorch-Fock-Schule",
  "Gretel-Bergmann-Schule",
  "Grund- und Stadtteilschule Alter Teichweg",
  "Grund- und Stadtteilschule Altrahlstedt",
  "Grund- und Stadtteilschule Eppendorf",
  "Grundschule Am Baakenhafen",
  "Grundschule Am Heidberg",
  "Grundschule An der Haake",
  "Grundschule Archenholzstraße",
  "Grundschule Arnkielstraße",
  "Grundschule Ballerstaedtweg",
  "Grundschule Bindfeldweg",
  "Grundschule Bramfeld",
  "Grundschule Eckerkoppel",
  "Grundschule Edwin-Scharff-Ring",
  "Grundschule Franzosenkoppel",
  "Grundschule Groß Flottbek",
  "Grundschule Großlohering",
  "Grundschule Hasenweg",
  "Grundschule Heidhorst",
  "Grundschule Hoheluft",
  "Grundschule Horn",
  "Grundschule Islandstraße",
  "Grundschule Kirchdorf",
  "Grundschule Kirchwerder",
  "Grundschule Lohkampstraße",
  "Grundschule Luruper Hauptstraße",
  "Grundschule Marienthal",
  "Grundschule Mendelstraße",
  "Grundschule Neugraben",
  "Grundschule Neurahlstedt",
  "Grundschule Nydamer Weg",
  "Grundschule Osterbrook",
  "Grundschule Poppenbüttel",
  "Grundschule Rahewinkel",
  "Grundschule Sachsenweg",
  "Grundschule Schule Scheeßeler Kehre",
  "Grundschule Sinstorfer Weg",
  "Grundschule St. Nikolai",
  "Grundschule St.Pauli",
  "Grundschule Thadenstraße",
  "Grundschule Tonndorf",
  "Grundschule am Gut",
  "Grundschule am Kiefernberg",
  "Gymnasium Allee",
  "Gymnasium Allermöhe",
  "Gymnasium Alstertal",
  "Gymnasium Altona",
  "Gymnasium Blankenese",
  "Gymnasium Bondenwald",
  "Gymnasium Bornbrook",
  "Gymnasium Buckhorn",
  "Gymnasium Corveystraße",
  "Gymnasium Dörpsweg",
  "Gymnasium Eppendorf",
  "Gymnasium Farmsen",
  "Gymnasium Finkenwerder",
  "Gymnasium Grootmoor",
  "Gymnasium Heidberg",
  "Gymnasium Hochrad",
  "Gymnasium Hoheluft",
  "Gymnasium Hummelsbüttel",
  "Gymnasium Kaiser-Friedrich-Ufer",
  "Gymnasium Klosterschule",
  "Gymnasium Lerchenfeld",
  "Gymnasium Lohbrügge",
  "Gymnasium Marienthal",
  "Gymnasium Meiendorf",
  "Gymnasium Neugraben",
  "Gymnasium Oberalster",
  "Gymnasium Ohmoor",
  "Gymnasium Oldenfelde",
  "Gymnasium Osterbek",
  "Gymnasium Othmarschen",
  "Gymnasium Rahlstedt",
  "Gymnasium Rissen",
  "Gymnasium Rotherbaum",
  "Gymnasium Süderelbe",
  "Gymnasium im Eilbektal",
  "Gyula Trebitsch Schule Tonndorf",
  "Hansa-Gymnasium Bergedorf",
  "Hansa-Kolleg",
  "Heilwig-Gymnasium",
  "Heinrich-Heine-Gymnasium",
  "Heinrich-Hertz-Schule",
  "Heinrich-Wolgast-Schule",
  "Heisenberg-Gymnasium",
  "Helene-Lange-Gymnasium",
  "Helmut-Schmidt-Gymnasium",
  "Ida Ehre Schule",
  "Ilse-Löwenstein-Schule",
  "Immanuel-Kant-Gymnasium",
  "Irena-Sendler-Schule",
  "Johannes-Brahms-Gymnasium",
  "Julius-Leber-Schule",
  "Katharinenschule in der Hafencity",
  "Kurt-Juster-Schule",
  "Kurt-Körber-Gymnasium",
  "Lessing-Stadtteilschule",
  "Lise-Meitner-Gymnasium",
  "Loki-Schmidt-Schule",
  "Louise Schroeder Schule",
  "Louise Weiss Gymnasium",
  "Luisen-Gymnasium Bergedorf",
  "Margaretha-Rothe-Gymnasium",
  "Marie-Beschütz-Schule",
  "Marion Dönhoff Gymnasium",
  "Matthias-Claudius-Gymnasium",
  "Max-Brauer-Schule",
  "Max-Schmeling-Stadtteilschule",
  "Max-Traeger-Schule",
  "Nelson-Mandela-Schule im Stadtteil Kirchdorf",
  "Otto-Hahn-Schule",
  "ReBBZ Altona-West",
  "ReBBZ Bergedorf",
  "ReBBZ Billstedt",
  "ReBBZ Eimsbüttel",
  "ReBBZ Harburg",
  "ReBBZ Mitte",
  "ReBBZ Nord",
  "ReBBZ Süderelbe",
  "ReBBZ Wandsbek-Nord",
  "ReBBZ Wandsbek-Süd",
  "ReBBZ Wilhelmsburg",
  "ReBBZ Winterhude Brucknerstraße",
  "ReBBZ Winterhude Lämmersieth",
  "Rudolf-Roß-Grundschule",
  "Schule Ahrensburger Weg",
  "Schule Alsterdorfer Straße",
  "Schule Alsterredder",
  "Schule Altengamme-Deich",
  "Schule Am Schleemer Park",
  "Schule Am Sooren",
  "Schule An den Teichwiesen",
  "Schule An der Burgweide",
  "Schule An der Gartenstadt",
  "Schule An der Glinder Au",
  "Schule An der Isebek",
  "Schule Anna-Susanna-Stieg",
  "Schule Appelhoff",
  "Schule Arp-Schnitger-Stieg",
  "Schule Bahrenfelder Straße",
  "Schule Bandwirkerstraße",
  "Schule Barlsheide",
  "Schule Beim Pachthof",
  "Schule Bekassinenau",
  "Schule Bekkamp",
  "Schule Bergstedt",
  "Schule Bonhoefferstraße",
  "Schule Bovestraße",
  "Schule Brehmweg",
  "Schule Brockdorffstraße",
  "Schule Buckhorn",
  "Schule Burgunderweg",
  "Schule Charlottenburger Straße",
  "Schule Cranz",
  "Schule Curslack-Neuengamme",
  "Schule Dempwolffstraße",
  "Schule Duvenstedter Markt",
  "Schule Döhrnstraße",
  "Schule Eduardstraße",
  "Schule Eenstock",
  "Schule Elfenwiese",
  "Schule Ernst-Henning-Straße",
  "Schule Eulenkrugstraße",
  "Schule Fabriciusstraße",
  "Schule Fahrenkrön",
  "Schule Forsmannstraße",
  "Schule Friedrich-Frank-Bogen",
  "Schule Frohmestraße",
  "Schule Fuchsbergredder",
  "Schule Furtweg",
  "Schule Fünfhausen-Warwisch",
  "Schule Genslerstraße",
  "Schule Grumbrechtstraße",
  "Schule Grützmühlenweg",
  "Schule Hasselbrook",
  "Schule Heidacker",
  "Schule Heinrich-Helbing-Straße",
  "Schule Hinsbleek",
  "Schule Hinter der Lieth",
  "Schule Hirtenweg",
  "Schule Hohe Landwehr",
  "Schule Humboldtstraße",
  "Schule Iserbarg",
  "Schule Iserbrook",
  "Schule Jenfelder Straße",
  "Schule Kamminer Straße",
  "Schule Kapellenweg",
  "Schule Kielkamp",
  "Schule Kielortallee",
  "Schule Klein Flottbeker Weg",
  "Schule Knauerstraße",
  "Schule Krohnstieg",
  "Schule Kroonhorst",
  "Schule Langbargheide",
  "Schule Lehmkuhlenweg",
  "Schule Lemsahl-Mellingstedt",
  "Schule Leuschnerstraße",
  "Schule Lokstedter Damm",
  "Schule Lutterothstraße",
  "Schule Lämmersieth",
  "Schule Marckmannstraße",
  "Schule Maretstraße",
  "Schule Marmstorf",
  "Schule Marschweg",
  "Schule Max-Eichholz-Ring",
  "Schule Mendelssohnstraße",
  "Schule Mittlerer Landweg",
  "Schule Molkenbuhrstraße",
  "Schule Moorflagen",
  "Schule Müssenredder",
  "Schule Nettelnburg",
  "Schule Neubergerweg",
  "Schule Ochsenwerder",
  "Schule Ohkamp",
  "Schule Ohrnsweg",
  "Schule Oppelner Straße",
  "Schule Paracelsusstraße",
  "Schule Potsdamer Straße",
  "Schule Rahlstedter Höhe",
  "Schule Ratsmühlendamm",
  "Schule Redder",
  "Schule Rellinger Straße",
  "Schule Richardstraße",
  "Schule Rotenhäuser Damm",
  "Schule Rothestraße",
  "Schule Rungwisch",
  "Schule Rönneburg",
  "Schule Rönnkamp",
  "Schule Röthmoorweg",
  "Schule Sander Straße",
  "Schule Scheeßeler Kehre",
  "Schule Schenefelder Landstraße",
  "Schule Schnuckendrift",
  "Schule Schulkamp",
  "Schule Sethweg",
  "Schule Speckenreye",
  "Schule Stengelestraße",
  "Schule Sterntalerstraße",
  "Schule Stockflethweg",
  "Schule Strenge",
  "Schule Stübenhofer Weg",
  "Schule Surenland",
  "Schule Tegelweg",
  "Schule Tornquiststraße",
  "Schule Traberweg",
  "Schule Trenknerweg",
  "Schule Turmweg",
  "Schule Vizelinstraße",
  "Schule Wegenkamp",
  "Schule Weidemoor",
  "Schule Wesperloh",
  "Schule Wielandstraße",
  "Schule Wildschwanbrook",
  "Schule Windmühlenweg",
  "Schule Zollenspieker",
  "Schule am Eichtalpark",
  "Schule am Park",
  "Schule am See",
  "Schule am Walde",
  "Schule auf der Uhlenhorst",
  "Schule auf der Veddel",
  "Stadtteilschule Altona",
  "Stadtteilschule Am Hafen",
  "Stadtteilschule Am Heidberg",
  "Stadtteilschule Bergedorf",
  "Stadtteilschule Bergstedt",
  "Stadtteilschule Blankenese",
  "Stadtteilschule Bramfeld",
  "Stadtteilschule Eidelstedt",
  "Stadtteilschule Fischbek-Falkenberg",
  "Stadtteilschule Flottbek",
  "Stadtteilschule Hamburg-Mitte",
  "Stadtteilschule Helmuth Hübener",
  "Stadtteilschule Horn",
  "Stadtteilschule In den Reethen",
  "Stadtteilschule Lohbrügge",
  "Stadtteilschule Lurup",
  "Stadtteilschule Max-Brauer-Schule",
  "Stadtteilschule Meiendorf",
  "Stadtteilschule Mümmelmannsberg",
  "Stadtteilschule Niendorf",
  "Stadtteilschule Oldenfelde",
  "Stadtteilschule Poppenbüttel",
  "Stadtteilschule Richard-Linde-Weg",
  "Stadtteilschule Rissen",
  "Stadtteilschule Stellingen",
  "Stadtteilschule Süderelbe",
  "Stadtteilschule Walddörfer",
  "Stadtteilschule Wilhelmsburg",
  "Stadtteilschule Öjendorf",
  "Struensee Gymnasium",
  "Theodor-Haubach-Schule",
  "Walddörfer-Gymnasium",
  "Westerschule Finkenwerder",
  "Wolfgang-Borchert-Schule"
];
